/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { WorkedUnit } from './';
import {
    WorkedUnitFromJSON,
    WorkedUnitFromJSONTyped,
    WorkedUnitToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectBudgetResourceWork
 */
export interface ProjectBudgetResourceWork {
    /**
     * 
     * @type {WorkedUnit}
     * @memberof ProjectBudgetResourceWork
     */
    unit?: WorkedUnit;
    /**
     * 
     * @type {number}
     * @memberof ProjectBudgetResourceWork
     */
    invoiced: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectBudgetResourceWork
     */
    remaining: number;
}

/**
 * Check if a given object implements the ProjectBudgetResourceWork interface.
 */
export function instanceOfProjectBudgetResourceWork(value: object): value is ProjectBudgetResourceWork {
    if (!('invoiced' in value) || value['invoiced'] === undefined) return false;
    if (!('remaining' in value) || value['remaining'] === undefined) return false;
    return true;
}

export function ProjectBudgetResourceWorkFromJSON(json: any): ProjectBudgetResourceWork {
    return ProjectBudgetResourceWorkFromJSONTyped(json, false);
}

export function ProjectBudgetResourceWorkFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectBudgetResourceWork {
    if (json == null) {
        return json;
    }
    return {
        
        'unit': json['unit'] == null ? undefined : WorkedUnitFromJSON(json['unit']),
        'invoiced': json['invoiced'],
        'remaining': json['remaining'],
    };
}

export function ProjectBudgetResourceWorkToJSON(value?: ProjectBudgetResourceWork | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'unit': WorkedUnitToJSON(value['unit']),
        'invoiced': value['invoiced'],
        'remaining': value['remaining'],
    };
}

